import { Getter } from "vuex";
import { IState } from './state';

const isToc: Getter<IState, IState> = (state) => state.isToc;

export default {
	isToc
}
